<!-- Example for client, how to redirect deeplink -->
<template>
  <component
    :is="page"
    @navigate="navigate"
    @reload="check"
    :errorType="errorType"
    :warningType="warningType"
  />
</template>

<script>
import Checking from "../pages/Checking.vue";
import Error from "../pages/Error.vue";
import MobileWarning from "../pages/MobileWarning.vue";
import { isAndroid } from "mobile-device-detect";

export default {
  components: {
    Checking,
    Error,
    MobileWarning,
  },
  name: "MobileAuthCheck",
  data() {
    return {
      page: "Checking",
      errorType: "canceled",
      warningType: "differentBrowser",
    };
  },
  mounted() {
    if (isAndroid) {
      this.navigate({
        page: "MobileWarning",
        warningType: "differentBrowser",
      });
      return;
    }
    document.addEventListener("visibilitychange", this.checkVisibilityState);
    this.check();
  },
  beforeDestroy() {
    document.removeEventListener("visibilitychange", this.checkVisibilityState);
  },
  methods: {
    navigate(val) {
      this.errorType = val.errorType;
      this.warningType = val.warningType;
      this.page = val.page;
    },
    check() {
      const loginChallenge = localStorage.getItem("login_challenge");
      if (!loginChallenge) {
        this.navigate({
          page: "MobileWarning",
          warningType: "differentBrowser",
        });
        return;
      }
      this.getStatus(loginChallenge);
    },
    async getStatus(loginChallenge) {
      try {
        const res = await fetch(
          "https://" +
            process.env.VUE_APP_API +
            ".x-id.io/authorization/status?login_challenge=" +
            loginChallenge,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            cache: "no-cache",
          }
        );
        if (!res.ok) {
          if (res.status == 404) {
            return;
          }
          this.$router.push({
            name: "reuse",
          });
          return;
        }
        const resData = await res.json();
        this.checkStatus(resData);
      } catch (error) {
        return;
      }
    },
    checkStatus(resData) {
      switch (resData.status) {
        case "Success":
          window.location.replace(resData.redirect_url);
          break;
        case "Expired":
          this.$router.push({
            name: "expired",
            query: {
              redirectURL: resData.redirect_url,
            },
          });
          break;
        case "Canceled":
          this.$router.push({
            name: "canceled",
            query: {
              redirectURL: resData.redirect_url,
            },
          });
          break;
        default:
          break;
      }
    },
    checkVisibilityState() {
      if (document.visibilityState === "visible") {
        setTimeout(this.check, 2000);
      }
    },
  },
};
</script>